export class FormaPago {

    constructor({ tipoFrmEmpresa }) {
        this.tipoFrmEmpresa = tipoFrmEmpresa;

        this.model = {
            id: { value: null, export: false },
            idp: { value: null, export: false },
            tipo_pago: {
                value: null,
                export: false,
                header: 'Medio de Pago',
                required: 'Medio de Pago es requerido',
                filterField: 'nombre',
                table: true,
                filter: false,
                sort: true,
            },
            valor: {
                value: 0,
                export: false,
                header: 'Valor USD:',
                required: 'Valor es requerido',
                table: true,
                filter: false,
                sort: true,
            },
            detalle: {
                value: '',
                export: false,
                header: 'Detalle',
                required: 'Detalle es requerido',
                table: false,
                tablePorTipo: {
                    FRM_TOYOTA: true,
                },
                filter: false,
                sort: true,
                min: 3,
                max: 150,
                minLength: 'Detalle debe tener al menos 3 caracteres',
                maxLength: 'Detalle debe tener máximo 150 caracteres',
            },
        }

        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.tablePorTipo && tipoFrmEmpresa && campo.tablePorTipo[tipoFrmEmpresa] !== undefined) {
                campo.table = campo.tablePorTipo[tipoFrmEmpresa];
            }
        });
    }

    optionLabel = 'nombre'
}